import InputBase from '@material-ui/core/InputBase';
import Paper from '@material-ui/core/Paper';
import PropTypes from 'prop-types';
import SearchIcon from '@material-ui/icons/Search';
import { withStyles } from '@material-ui/core/styles';
import KeyboardEventHandler from 'react-keyboard-event-handler';
import { styles } from './SearchBar.styles';
import IconButton from '../IconButton';

const SearchBar = props => {
  const { classes, label, value, onChange, onClick, onBlur, style } = props;

  return (
    <KeyboardEventHandler handleKeys={['enter']} onKeyEvent={() => onClick()}>
      <Paper className={classes.root} style={style} elevation={1}>
        <InputBase
          className={classes.input}
          placeholder={label || 'Rechercher un client'}
          value={value}
          onBlur={onBlur}
          onChange={onChange}
        />
        <IconButton className={classes.iconButton} label="Search">
          <SearchIcon onClick={onClick} />
        </IconButton>
      </Paper>
    </KeyboardEventHandler>
  );
};


SearchBar.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onBlur: PropTypes.func,
  style: PropTypes.object
};

export default withStyles(styles)(SearchBar);
